import React from "react";
import {cx} from "../../lib/ClassSet";

const MigrationItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "onboarding-migration-list-item": true,
    "u-selected": props.selected
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("customerId")}</td>
      <td className="field f-name">{data.get("name")}</td>
      <td className="field f-email">{data.get("email")}</td>
      <td className="field">{data.get("subsActive")}</td>
      <td className="field f-status">{data.get("status")}</td>
    </tr>
  )
}

export default MigrationItem;